module.exports = __webpack_public_path__ + "img/empty.2772f08e.svg";